import Image from 'next/image';
import type { CSSProperties, JSX } from 'react';

interface DeviceTypeImageProps {
  src?: string;
  alt: string;
  style?: CSSProperties;
  shadow?: boolean;
}

const DEFAULT_SHADOW_STYLE = `drop-shadow(0px 5px 10px rgba(38, 51, 77, 0.19))`;

const DeviceTypeImage = ({
  src,
  alt,
  style,
  shadow = true,
}: DeviceTypeImageProps): JSX.Element | null => {
  if (!src) return null;

  return (
    <Image
      src={src}
      alt={alt}
      width={150}
      height={237}
      loading="eager"
      style={{
        filter: shadow ? DEFAULT_SHADOW_STYLE : undefined,
        ...style,
      }}
    />
  );
};

export default DeviceTypeImage;
